module.exports = __webpack_public_path__ + "static/media/surface_laptop2.330c36f6.png";